var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"8"}},[_c('GChart',{attrs:{"type":"PieChart","data":_vm.values,"options":_vm.chartOptions}}),_c('v-card-title',[_vm._v(" Prevalenza categorie ultimo mese ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }